import { render, staticRenderFns } from "./add-validation-flow.vue?vue&type=template&id=448dfe1d&scoped=true"
import script from "./add-validation-flow.vue?vue&type=script&lang=js"
export * from "./add-validation-flow.vue?vue&type=script&lang=js"
import style0 from "./add-validation-flow.vue?vue&type=style&index=0&id=448dfe1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448dfe1d",
  null
  
)

export default component.exports